"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachBrandSetupComponent = void 0;
var react_1 = __importDefault(require("react"));
var BrandSetup_1 = __importDefault(require("DreamCoat/BrandSetUp/BrandSetup"));
var attachBrandSetupComponent = function (mountReactComponent, brandStore, stylePermissionStore, uploadStore, explorePlans, fontService, usingFeature) {
    return mountReactComponent(react_1.default.createElement(BrandSetup_1.default, { brandStore: brandStore, stylePermissionStore: stylePermissionStore, uploadStore: uploadStore, explorePlans: explorePlans, fontService: fontService, usingFeature: usingFeature }));
};
exports.attachBrandSetupComponent = attachBrandSetupComponent;
